export const uniqBy = <T>(arr: Array<T>, predicate: (o: T) => string): Array<T> => {
  if (!Array.isArray(arr)) {
    return [];
  }

  const cb = typeof predicate === 'function' ? predicate : (o: T) => o[predicate];

  const pickedObjects = arr
    .filter((item: T) => item)
    .reduce((map, item) => {
      const key = cb(item);

      if (!key) {
        return map;
      }

      return map.has(key) ? map : map.set(key, item);
    }, new Map())
    .values();

  return [...pickedObjects];
};
